export default function Logo({ size = 40, glow = false, withText = false }) {
  return (
    <div className="row gap-3" style={{ alignItems: 'center' }}>
      <div style={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
        background: '#000',
        border: '1.5px solid rgba(225,18,23,0.55)',
        boxShadow: glow ? '0 0 22px -4px var(--accent-glow)' : 'none',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <img
          src="/assets/logo-federation.png"
          alt="CS2 Federation"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
      {withText && (
        <div className="col" style={{ lineHeight: 1 }}>
          <span className="display" style={{ fontSize: 17, letterSpacing: '0.02em' }}>Федерация киберспорта</span>
          <span className="mono" style={{ fontSize: 9.5, letterSpacing: '0.22em', color: 'var(--fg-muted)', marginTop: 3 }}>СКО · ПЕТРОПАВЛОВСК</span>
        </div>
      )}
    </div>
  );
}
